export default __webpack_public_path__ + "static/media/marker.fec4a2ab.svg";